module.exports = __webpack_public_path__ + "static/media/iphone_13_mini_red.b17fcfbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_mini_red.png
// module id = 2115
// module chunks = 0